export default [
  {
    Companies: [
      {
        fileName: "login/companii/Homepage4.jpg",
        link:
          "https://upmoldova.md/tichete-cadou/",
        category: "Banner",
        action: "Click",
        label: "companii_login4",
      },
      {
        fileName: "login/companii/Homepage3.jpg",
        link:
          "https://upmoldova.md/",
        category: "Banner",
        action: "Click",
        label: "companii_login3",
      },
      {
        fileName: "login/companii/Homepage1.jpg",
        link:
          "#",
        category: "Banner",
        action: "Click",
        label: "companii_login",
      },
      {
        fileName: "login/companii/Homepage2.jpg",
        link:
          "#",
        category: "Banner",
        action: "Click",
        label: "companii_login2",
      },
    ],
    Beneficiaries: [
      {
        fileName: "login/utilizatori/Homepage.jpg",
        link:
          "#",
        category: "Banner",
        action: "Click",
        label: "beneficiari_login",
      },
    ],
  },
];
